<template>
  <div>
    <Breadcrumbs main="Dashboard" title="Kontrol Paneli" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-12">
          <TurRezervasyonList />
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <ul class="nav nav-tabs border-tab tabs-scoial" id="top-tab" role="tablist">
            <li class="nav-item" v-on:click="changetab('acentelist')">
              <a class="nav-link" :class="[
              { 'show active': showtab == 'acentelist' }
            ]" id="top-acentelist" data-toggle="tab" role="tab" aria-controls="acentelist" aria-selected="true">ONAY
                BEKLEYEN ACENTELER <b-badge variant="primary">{{ acente_sayisi }}</b-badge></a>
            </li>
            <li class="nav-item" v-on:click="changetab('rehberlist')">
              <a class="nav-link" :class="[
              { 'show active': showtab == 'rehberlist' }
            ]" id="top-rehberlist" data-toggle="tab" role="tab" aria-controls="rehberlist" aria-selected="true">ONAY
                BEKLEYEN REHBERLER <b-badge variant="primary">{{ rehber_sayisi }}</b-badge></a>
            </li>
            <li class="nav-item" v-on:click="changetab('araclist')">
              <a class="nav-link" :class="[
              { 'show active': showtab == 'araclist' }
            ]" id="top-araclist" data-toggle="tab" role="tab" aria-controls="araclist" aria-selected="false">ONAY
                BEKLEYEN ARAÇLAR
                <b-badge variant="primary">{{ arac_sayisi }}</b-badge></a>
            </li>
            <li class="nav-item" v-on:click="changetab('aracresimlist')">
              <a class="nav-link" :class="[
              { 'show active': showtab == 'aracresimlist' }
            ]" id="top-aracresimlist" data-toggle="tab" role="tab" aria-controls="aracresimlist"
                aria-selected="false">ONAY BEKLEYEN ARAÇ RESİMLERİ
                <b-badge variant="primary">{{ aracresim_sayisi }}</b-badge></a>
            </li>
          </ul>
        </div>
      </div>

      <div class="tab-content" id="top-tabContent">
        <div class="tab-pane fade" :class="{ 'show active': showtab == 'acentelist' }" id="acentelist" role="tabpanel"
          aria-labelledby="acentelist">
          <AcenteOnayBekleyenList @rowcount="(sayi) => { acente_sayisi = sayi }" />
        </div>

        <div class="tab-pane fade" :class="{ 'show active': showtab == 'rehberlist' }" id="rehberlist" role="tabpanel"
          aria-labelledby="rehberlist">
          <RehberOnayBekleyenList @rowcount="(sayi) => { rehber_sayisi = sayi }" />
        </div>

        <div class="tab-pane fade" :class="{ 'show active': showtab == 'araclist' }" id="araclist" role="tabpanel"
          aria-labelledby="araclist">
          <AracOnayBekleyenList @rowcount="(sayi) => { arac_sayisi = sayi }" />
        </div>

        <div class="tab-pane fade" :class="{ 'show active': showtab == 'aracresimlist' }" id="aracresimlist"
          role="tabpanel" aria-labelledby="aracresimlist">
          <AracResimOnayBekleyenList  @rowcount="(sayi) => { aracresim_sayisi = sayi }" />
        </div>
      </div>

    </div>

    <DuyuruGosterimModal />
  </div>
</template>
<script>
import TurRezervasyonList from "@/components/c_tur_rezervasyon_dashboard_yonetim.vue";
import AcenteOnayBekleyenList from "@/components/c_dashboard_acente_onay_bekleyenler.vue";
import RehberOnayBekleyenList from "@/components/c_dashboard_rehber_onay_bekleyenler.vue";
import AracOnayBekleyenList from "@/components/c_dashboard_arac_onay_bekleyenler.vue";
import AracResimOnayBekleyenList from "@/components/c_dashboard_aracResim_onay_bekleyenler.vue";
import DuyuruGosterimModal from "@/components/c_duyuru_gosterim";

export default {
  data() {
    return {
      showtab: "acentelist",

      acente_sayisi: 0,
      rehber_sayisi: 0,
      arac_sayisi: 0,
      aracresim_sayisi: 0,
    };
  },
  components: {
    TurRezervasyonList,
    AcenteOnayBekleyenList,
    RehberOnayBekleyenList,
    AracOnayBekleyenList,
    AracResimOnayBekleyenList,
    DuyuruGosterimModal,
  },
  mounted() {
    let user = this.$user.getUser();
    if (user.Kullanici.RedirectUrl !== "/dashboard/default")
      this.$router.push(user.Kullanici.RedirectUrl);
  },
  methods: {
    changetab(tab) {
      this.showtab = tab;
    },
  }
};
</script>
